import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EnvironmentInjector } from '@next/core-lib/environment';

import { RoughagePlusEnvironment } from 'src/environments/environment.model';

import { MonitorSegment } from '../models/monitor-segments.model';
import { MonitorData } from './request-models/get-monitor-data.model';

@Injectable({
  providedIn: 'root',
})
export class MonitorService {
  private readonly http = inject(HttpClient);
  private readonly environment =
    inject<RoughagePlusEnvironment>(EnvironmentInjector);

  private readonly monitorTypes = {
    [MonitorSegment.Grass]: 'Grass',
    [MonitorSegment.Mow]: 'Mowing',
    [MonitorSegment.GrassOrganic]: 'GrassBio',
    [MonitorSegment.Maize]: 'Maize',
  };

  public getMonitorData(type: MonitorSegment) {
    return this.http.get<MonitorData>(
      `${this.environment.API_BASE_URL}/service/dairy-advice/secure/monitor`,
      { params: { type: this.monitorTypes[type] } },
    );
  }
}
